import { render, staticRenderFns } from "./motionFollowDetail.vue?vue&type=template&id=adce85a8&scoped=true&"
import script from "./motionFollowDetail.vue?vue&type=script&lang=js&"
export * from "./motionFollowDetail.vue?vue&type=script&lang=js&"
import style0 from "./motionFollowDetail.vue?vue&type=style&index=0&id=adce85a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adce85a8",
  null
  
)

export default component.exports